import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import ReCAPTCHA from '../../../../../components/ReCaptcha';
import {
  Button,
  ErrorMessage,
  FieldErrorMessage,
  FormContainer,
  HelperText,
  Input,
  Label,
  RecaptchaWrapper,
} from './styles';
import InfoTooltip from '../../../../../components/InfoTooltip';

function CheckForm(props) {
  const {
    prn,
    setprn,
    error,
    setError,
    recaptchaRef,
    handleChange,
    handleExpire,
    handleSubmit,
    loading,
    isValid,
    page,
    isGalileo
  } = props;
  const [fieldError, setfieldError] = useState(null);
  const intl = useIntl();
  const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const tooltipContent = (
    <>
      <p>
        <strong>{intl.messages[`${page}-prndetailtitle`]}</strong>
      </p>
      <br />
      <p>{intl.messages[`${page}-prnhelperdetaildescription`]}</p>
    </>
  );

  const handleValidation = e => {
    if (!prn) {
      setfieldError('prninputerrormsg');
      return;
    }

    setfieldError(null);
    setError(null);
    handleSubmit(e);
  };

  return (
    <FormContainer>
      <Label htmlFor="prn">{intl.messages[`${page}-prninputlabel`]}</Label>
      <Input
        type="text"
        inputMode="numeric"
        placeholder={intl.messages[`${page}-prninputplaceholder${isGalileo ? 'galileo' : ''}`]}
        name="prn"
        value={prn}
        onChange={e => setprn(e.target.value)}
        className={`${fieldError ? 'is-invalid' : ''}`}
        maxLength={12}
        autoComplete="on"
        onBeforeInput={e => {
          if (!/^\d*$/.test(e.data)) {
            e.preventDefault();
          }
        }}
        disabled={loading}
      />
      {fieldError && (
        <FieldErrorMessage>
          {intl.messages[`${page}-${fieldError}`]}
        </FieldErrorMessage>
      )}
      <HelperText>
        <p>{intl.messages[`${page}-prnhelpertext`]}</p>
        <InfoTooltip content={tooltipContent} />
      </HelperText>
      <RecaptchaWrapper>
        <ReCAPTCHA
          ref={recaptchaRef}
          sitekey={SITE_KEY}
          onChange={handleChange}
          onExpired={handleExpire}
          onError={handleExpire}
        />
      </RecaptchaWrapper>
      <Button
        type="button"
        onClick={handleValidation}
        title="Search with PRN"
        disabled={loading || !isValid()}
        className={`${loading ? 'is-loading' : ''}`}
      >
        {loading ? (
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity=".2"
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 19a7 7 0 1 0 0-14 7 7 0 0 0 0 14m0 3c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10"
              fill="#fff"
            />
            <path
              d="M12 22c5.523 0 10-4.477 10-10h-3a7 7 0 0 1-7 7zM2 12C2 6.477 6.477 2 12 2v3a7 7 0 0 0-7 7z"
              fill="#fff"
            />
          </svg>
        ) : (
          intl.messages[`${page}-submit_title`]
        )}
      </Button>
      {error && (
        <ErrorMessage>
          <svg
            width="30"
            height="30"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              opacity="0.4"
              d="M22 9V16.4667C22 18.7667 20.1333 20.6 17.8667 20.6H6.13333C3.86667 20.6 2 18.7667 2 16.4667V9H22Z"
              fill="#c30344"
            />
            <path
              d="M22 7.53324V8.9999H2V7.53324C2 5.26657 3.86667 3.3999 6.13333 3.3999H17.8333C20.1333 3.3999 22 5.26657 22 7.53324Z"
              fill="#c30344"
            />
            <path
              d="M8 17.2333H6C5.6 17.2333 5.26666 16.8999 5.26666 16.4999C5.26666 16.0999 5.6 15.7666 6 15.7666H8C8.4 15.7666 8.73333 16.0999 8.73333 16.4999C8.73333 16.8999 8.4 17.2333 8 17.2333Z"
              fill="#c30344"
            />
            <path
              d="M14.5 17.2333H10.5C10.1 17.2333 9.76666 16.8999 9.76666 16.4999C9.76666 16.0999 10.1 15.7666 10.5 15.7666H14.5C14.9 15.7666 15.2333 16.0999 15.2333 16.4999C15.2333 16.8999 14.9 17.2333 14.5 17.2333Z"
              fill="#c30344"
            />
          </svg>
          <p>{error || intl.messages[`${page}-prnnotfounderrormsg`]}</p>
        </ErrorMessage>
      )}
    </FormContainer>
  );
}

CheckForm.propTypes = {
  prn: PropTypes.string,
  setprn: PropTypes.func,
  error: PropTypes.bool,
  setError: PropTypes.func,
  handleSubmit: PropTypes.func,
  loading: PropTypes.bool,
  isValid: PropTypes.func,
  handleChange: PropTypes.func,
  handleExpire: PropTypes.func,
  recaptchaRef: PropTypes.shape({}),
  page: PropTypes.string,
  isGalileo: PropTypes.bool,
};

CheckForm.defaultProps = {
  prn: '',
  setprn: () => {},
  error: false,
  setError: () => {},
  handleSubmit: () => {},
  loading: false,
  isValid: () => {},
  handleChange: () => {},
  handleExpire: () => {},
  recaptchaRef: {},
  page: '',
  isGalileo: false,
};

export default CheckForm;
